import { NgModule }      from '@angular/core';
import { BrowserClipboardService } from './browserClipboard.service';

@NgModule({
  providers: [ BrowserClipboardService]
})
export class BrowserClipboardModule {  }